<template>
  <b-form @submit.prevent="submit" class="flex-center">
    <AuthWrapper
      :label="`${$lang.login} | ${$lang.register}`"
      leftIcon="help-circle-outline"
      :leftIconTooltip="$lang.problem_login_link_caption"
      @handleLeftIcon="goToContactUs"
    >
      <template #main>
        <b-row>
          <b-col cols="12" md="12">
            <Input
              :title="$lang.enter_username_or_mobile"
              :label="$lang.username_or_mobile"
              :placeholder="$lang.username_or_mobile"
              :value="form.username"
              name="username"
              id="username"
              type="text"
              :minLength="lengthNumber5"
              :maxLength="lengthNumber16"
              :vuelidateObj="$v.form.username"
              @input="input"
              @focus="resetValidation"
              @blur="checkValidation"
            />
            <!-- created element password input just for use browser suggestion username -->
            <input type="password" class="d-none" />
          </b-col>
          <b-col cols="12" md="12">
            <Captcha
              :value="form.captcha"
              id="captcha"
              name="captcha"
              :minLength="captchaLength"
              :maxLength="captchaLength"
              :vuelidateObj="$v.form.captcha"
              @input="input"
              @getKey="updateCaptchaKey"
              @setShowCaptcha="setShowCaptcha"
              @focus="resetValidation"
              @blur="checkValidation"
            />
          </b-col>
        </b-row>
      </template>
      <template #button>
        <b-row>
          <b-col cols="12" md="12">
            <Button
              class="w-100"
              contentClass="justify-content-center"
              variant="primary"
              :text="$lang.login"
              :loading="loading"
              type="submit"
              @click="submit"
            />
          </b-col>
        </b-row>
      </template>
    </AuthWrapper>
  </b-form>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { AuthWrapper } from "@/components/re-design";
import { Input, Captcha, Button } from "@/components/re-design/forms";
import {
  required,
  requiredIf,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { checkPersianCharValidation, goToRoute, storeDispatcher } from "@/shared/utils";
import { checkLogin } from "@/modules/auth/services";

export default {
  inject: ["setState", "goToContactUs"],
  mixins: [inputMixin],
  components: {
    AuthWrapper,
    Input,
    Captcha,
    Button,
  },
  validations() {
    return {
      form: {
        username: {
          required,
          persianCharacters: (val) => !checkPersianCharValidation(val),
          minLength: minLength(this.lengthNumber5),
          maxLength: maxLength(this.lengthNumber16),
        },
        captcha: {
          required: requiredIf(() => this.showCaptcha),
          minLength: minLength(this.captchaLength),
          maxLength: maxLength(this.captchaLength),
        },
      },
    };
  },
  data() {
    return {
      form: {
        username: null,
        captcha: null,
        captchaKey: null,
      },
      loading: false,
      state: "CHECK_LOGIN",
    };
  },
  methods: {
    pathOr,
    checkPersianCharValidation,
    goToRoute,
    async submit() {
      this.$v.$touch();
      if (this.$v.$anyError || this.loading) return;

      try {
        this.loading = true;
        const uName = this.form.username;
        const captcha = this.form.captcha;
        const key = this.form.captchaKey;
        const response = await checkLogin(uName, captcha, key);
        const { state, username } = response;
        if (state === "REGISTER") {
          return goToRoute("active-registrations", {}, {}, false);
        }
        this.$emit("setUsername", username);
        this.setState(state);
      } catch (error) {
        this.$generateError(error);
        storeDispatcher("shouldRefreshCaptcha", true);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
